import { useState } from 'react';
import DepositModal from '../components/DepositModal';
import '../styles/home.css';

function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePlayNowClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <section className="home">
        <div className="home-background">
          <img 
            src="https://images.unsplash.com/photo-1596386773283-c6f8e4c4f2f0?w=1920&h=1080&fit=crop&q=100" 
            alt="Luxury Casino" 
            className="home-image"
          />
        </div>

        <div className="home-overlay"></div>
        
        <div className="home-content">
          <h1 className="home-title">Welcome to GC</h1>
          <p className="home-subtitle">Experience Luxury Gaming Like Never Before</p>
          <button className="home-button" onClick={handlePlayNowClick}>
            Deposit
          </button>
        </div>
      </section>

      <DepositModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
}

export default Home;
